import * as React from "react";

import ContentFrame from "./ContentFrame";

import { CookieHost } from "./CookieManager/CookieHost";
import { installServiceWorker } from "./RegisterServiceWorker";
import { ServiceWorkerSetupDone } from "./Definitions/MessageTypes";

import "./Main.css";

function Main(): JSX.Element {
	const [isServiceWorkerSetUp, setIsServiceWorkerSetUp] = React.useState<boolean>(false);

	React.useEffect(() => {
		const initializationResponseMessageChannel = new MessageChannel();
		const cookieChannel = new MessageChannel();
		new CookieHost(cookieChannel.port1);

		window.addEventListener(
			"message",
			(event: MessageEvent) => {
				const referrerUrl = new URL(document.referrer);
				const senderUrl = new URL(event.origin);

				if (referrerUrl.origin !== senderUrl.origin) {
					console.error("Unauthorized sender location: ", senderUrl.origin);
					return;
				}
				installServiceWorker(
					referrerUrl,
					event.ports[0],
					cookieChannel.port2,
					initializationResponseMessageChannel.port2
				);
				initializationResponseMessageChannel.port1.onmessage = (
					messageResponseEvent: MessageEvent
				) => {
					if (messageResponseEvent.data?.type === ServiceWorkerSetupDone) {
						setIsServiceWorkerSetUp(true);
					} else {
						console.error("Received unrecognized message instead of acknowledge");
					}
				};
			},
			{ once: true }
		);
	}, []);

	return (
		<div className="App">
			{isServiceWorkerSetUp && (
				// TODO: Add an iframe ref in IOT-15500
				<ContentFrame iframeSrc={window.origin} />
			)}
		</div>
	);
}

export default Main;
